/**
 * Canonical founding Creator Plan offer — marketing, signup, and billing seed should stay aligned.
 * Checkout charges the Stripe Price linked to each billing plan row.
 */
export const FOUNDING_PRICING = {
  listAnnualUsd: 359.88,
  listMonthlyUsd: 29.99,
  presaleAnnualUsd: 179.94,
  foundingPlatformFeePercent: 5,
  listPlatformFeePercent: 10,
  foundingSlots: 100,
  launchDateLabel: '1 September 2026',
  /** UTC instant when post-launch list pricing replaces founding presale signup. */
  launchDateIso: '2026-09-01T00:00:00.000Z',
  /** Default plan slug during founding signup. */
  defaultPlanSlug: 'creator_plan_annual',
  /** Only annual checkout is offered during founding presale. */
  presalePlanSlug: 'creator_plan_annual',
} as const;

export function isFoundingPresaleActive(now = new Date()) {
  return now.getTime() < new Date(FOUNDING_PRICING.launchDateIso).getTime();
}

export const FOUNDING_PLAN_PERKS = [
  'Early access to Studio features',
  'Priority support',
  'Founding Studio badge',
] as const;

export function formatMarketingUsd(amount: number) {
  return amount.toLocaleString('en-US', {
    minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  });
}

export function foundingAmountCents(interval: 'month' | 'year') {
  return interval === 'year'
    ? Math.round(FOUNDING_PRICING.presaleAnnualUsd * 100)
    : Math.round(FOUNDING_PRICING.listMonthlyUsd * 100);
}

export function foundingPlanName(interval: 'month' | 'year') {
  return interval === 'year' ? 'Founding Studio Plan' : 'Creator Plan (Monthly)';
}

export function foundingPlanDescription(interval: 'month' | 'year') {
  if (interval === 'year') {
    return `Pay for 6 months · enjoy 12 months. First ${FOUNDING_PRICING.foundingSlots} signups before ${FOUNDING_PRICING.launchDateLabel}.`;
  }
  return 'Monthly Studio billing at standard list price.';
}
